module.exports = __webpack_public_path__ + "static/media/image_woman_step1.084575ab.png";